import styled from 'styled-components';

export const PhoneNumber = styled.a`
  display: grid;
  grid-template-columns: 35px 1fr;
  gap: 10px;
  align-items: center;
  height: 55px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  }
`;
